<div class="kc-labeled-tabs-container">
  <div class="kc-labeled-tabs-header">
    <div class="kc-labeled-tabs-prefix">
      <ng-content select="[slot=prefix]" />
    </div>

    <div class="kc-labeled-tabs-list">
      @for (tab of tabs(); track tab.id) {
        <div
          class="kc-labeled-tabs-item"
          [class.selected]="isSelected(tab.id)"
          [class.disabled]="tab.disabled"
          (click)="!tab.disabled && onTabClick(tab.id)"
        >
          {{ tab.label }}
        </div>
      }
    </div>

    <div class="kc-labeled-tabs-suffix">
      <ng-content select="[slot=suffix]" />
    </div>
  </div>

  <div class="kc-labeled-tabs-content">
    <ng-content />
  </div>
</div>
